"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticTypes = exports.PdfTemplateType = exports.PrinterConfigurationType = exports.CheckinAppType = exports.CheckinVisitorEventType = exports.CheckinVisitorType = exports.MyWorklogType = exports.WorklogType = exports.FormType = exports.EmailTemplateType = exports.EmailType = exports.TranslationType = exports.LanguageType = exports.CountryType = exports.LocaleType = exports.DataTypeType = exports.CronjobType = exports.DashboardType = exports.TaskType = exports.MessageType = exports.OrderType = exports.PriceZoneType = exports.ShoppingCartType = exports.SupplierType = exports.CustomBackofficeType = exports.DeviceType = exports.ConfigurationType = exports.OptinType = exports.ApplicationType = exports.CmsPageType = exports.ProductType = exports.WorkflowType = exports.FileType = exports.TodoTemplateType = exports.TodoType = exports.RoleType = exports.ContactType = exports.CalendarEntryType = exports.ExtensionSlotType = exports.CalendarType = exports.SubscriptionType = exports.DataTemplateType = exports.ProjectType = exports.ServiceTokenType = exports.CustomerType = exports.UserType = void 0;
const service_permissions_1 = require("./service-permissions");
const type_1 = require("./type");
exports.UserType = {
    icon: "contact-card",
    name: "users",
    permissions: {
        create: service_permissions_1.ServicePermissions.USERS_WRITE,
        delete: service_permissions_1.ServicePermissions.USERS_WRITE,
        read: service_permissions_1.ServicePermissions.USERS_READ,
        readAll: service_permissions_1.ServicePermissions.USERS_READ,
        update: service_permissions_1.ServicePermissions.USERS_WRITE
    },
    searchableFields: [
        { name: "profile.firstName", weight: 10 },
        { name: "profile.lastName", weight: 10 }
    ],
    toStringRepresentation: "${displayName}",
    url: "${backofficeProjectPath}/users?detailsId=${id}",
    tags: []
};
exports.CustomerType = Object.assign(Object.assign({}, exports.UserType), { name: "customers" });
exports.ServiceTokenType = {
    icon: "key",
    name: "servicetokens",
    permissions: {
        create: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        delete: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        read: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        readAll: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        update: service_permissions_1.ServicePermissions.TENANT_ADMIN
    },
    searchableFields: [{ name: "label", weight: 10 }],
    toStringRepresentation: "${label}",
    tags: []
};
exports.ProjectType = {
    icon: "web-design",
    name: "projects",
    permissions: {
        create: service_permissions_1.ServicePermissions.TENANT_READ,
        delete: service_permissions_1.ServicePermissions.TENANT_READ,
        read: service_permissions_1.ServicePermissions.TENANT_READ,
        readAll: service_permissions_1.ServicePermissions.TENANT_READ,
        update: service_permissions_1.ServicePermissions.TENANT_READ
    },
    searchableFields: [
        { name: "name", weight: 10 },
        { name: "path", weight: 6 }
    ],
    toStringRepresentation: "${name}",
    tags: []
};
exports.DataTemplateType = {
    icon: "database-restore",
    name: "DataTemplates",
    permissions: {
        create: service_permissions_1.ServicePermissions.DATA_TEMPLATES_WRITE,
        delete: service_permissions_1.ServicePermissions.DATA_TEMPLATES_WRITE,
        read: service_permissions_1.ServicePermissions.ANONYMOUS,
        readAll: service_permissions_1.ServicePermissions.ANONYMOUS,
        update: service_permissions_1.ServicePermissions.DATA_TEMPLATES_WRITE
    },
    searchableFields: [{ name: "label", weight: 10 }],
    toStringRepresentation: "${label}",
    tags: []
};
exports.SubscriptionType = {
    icon: "renew-subscription",
    name: "subscriptions",
    permissions: {
        create: service_permissions_1.ServicePermissions.SUBSCRIPTIONS_WRITE,
        delete: service_permissions_1.ServicePermissions.SUBSCRIPTIONS_WRITE,
        update: service_permissions_1.ServicePermissions.SUBSCRIPTIONS_WRITE,
        read: service_permissions_1.ServicePermissions.ANONYMOUS,
        readAll: service_permissions_1.ServicePermissions.ANONYMOUS
    },
    searchableFields: [
        { name: "name", weight: 10 },
        { name: "description", weight: 8 }
    ],
    toStringRepresentation: "${name}",
    tags: []
};
exports.CalendarType = {
    icon: "calendar--v1",
    name: "calendars",
    permissions: {
        create: service_permissions_1.ServicePermissions.CALENDAR_WRITE,
        delete: service_permissions_1.ServicePermissions.CALENDAR_WRITE,
        read: service_permissions_1.ServicePermissions.CALENDAR_READ,
        readAll: service_permissions_1.ServicePermissions.CALENDAR_READ,
        update: service_permissions_1.ServicePermissions.CALENDAR_WRITE
    },
    searchableFields: [
        {
            name: "name",
            weight: 10
        }
    ],
    toStringRepresentation: "${name}",
    tags: []
};
exports.ExtensionSlotType = {
    icon: "",
    name: "extensionslots",
    permissions: {
        create: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        delete: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        update: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        read: service_permissions_1.ServicePermissions.TENANT_READ,
        readAll: service_permissions_1.ServicePermissions.TENANT_READ
    },
    tags: []
};
exports.CalendarEntryType = {
    icon: "overtime",
    name: "calendarEntries",
    permissions: {
        create: service_permissions_1.ServicePermissions.CALENDAR_WRITE,
        delete: service_permissions_1.ServicePermissions.CALENDAR_WRITE,
        read: service_permissions_1.ServicePermissions.CALENDAR_READ,
        readAll: service_permissions_1.ServicePermissions.CALENDAR_READ,
        update: service_permissions_1.ServicePermissions.CALENDAR_WRITE
    },
    searchableFields: [
        {
            name: "name",
            weight: 10
        }
    ],
    toStringRepresentation: "${name}",
    tags: []
};
exports.ContactType = {
    icon: "contact-card",
    name: "contacts",
    permissions: {
        create: service_permissions_1.ServicePermissions.CONTACTS_WRITE,
        delete: service_permissions_1.ServicePermissions.CONTACTS_WRITE,
        read: service_permissions_1.ServicePermissions.CONTACTS_READ,
        readAll: service_permissions_1.ServicePermissions.CONTACTS_READ,
        update: service_permissions_1.ServicePermissions.CONTACTS_WRITE
    },
    searchableFields: [
        { name: "firstName", weight: 10 },
        { name: "lastName", weight: 10 },
        { name: "birthday", weight: 2 },
        { name: "address.street", weight: 2 },
        { name: "address.streetNumber", weight: 2 },
        { name: "address.name", weight: 2 },
        { name: "address.addition", weight: 2 },
        { name: "address.country", weight: 2 },
        { name: "address.state", weight: 2 },
        { name: "address.county", weight: 2 },
        { name: "address.zip", weight: 2 },
        { name: "address.city", weight: 2 },
        { name: "email", weight: 9 },
        { name: "phone", weight: 2 },
        { name: "mobile", weight: 2 },
        { name: "company", weight: 8 },
        { name: "companyPosition", weight: 2 },
        { name: "companyPhone", weight: 2 }
    ],
    toStringRepresentation: "${firstName} ${lastName}#{if company}, ${company}#{/if}",
    url: "${backofficeProjectPath}/contacts/list?openDetailsId=${id}",
    tags: [type_1.SmallstackTypeTag.COMMON, type_1.SmallstackTypeTag.LINK_FOR_CALENDAR, type_1.SmallstackTypeTag.LINK_FOR_TODO]
};
exports.RoleType = {
    icon: "conference-call",
    name: "roles",
    tags: [],
    permissions: {
        create: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        delete: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        read: service_permissions_1.ServicePermissions.TENANT_READ,
        readAll: service_permissions_1.ServicePermissions.TENANT_READ,
        update: service_permissions_1.ServicePermissions.TENANT_ADMIN
    },
    toStringRepresentation: "${name}",
    searchableFields: [
        { name: "name", weight: 10 },
        { name: "description", weight: 8 }
    ]
};
exports.TodoType = {
    icon: "todo-list--v1",
    name: "todos",
    permissions: {
        create: service_permissions_1.ServicePermissions.TODO_WRITE,
        delete: service_permissions_1.ServicePermissions.TODO_WRITE,
        read: service_permissions_1.ServicePermissions.TODO_READ,
        readAll: service_permissions_1.ServicePermissions.TODO_READ,
        update: service_permissions_1.ServicePermissions.TODO_WRITE
    },
    searchableFields: [
        { name: "label", weight: 10 },
        { name: "description", weight: 8 }
    ],
    toStringRepresentation: "${label}",
    url: "${backofficeProjectPath}/todos",
    tags: [type_1.SmallstackTypeTag.LINK_FOR_CALENDAR]
};
exports.TodoTemplateType = {
    icon: "todo-list--v1",
    name: "todoTemplates",
    permissions: {
        create: service_permissions_1.ServicePermissions.TODO_TEMPLATE_WRITE,
        delete: service_permissions_1.ServicePermissions.TODO_TEMPLATE_WRITE,
        read: service_permissions_1.ServicePermissions.TODO_TEMPLATE_READ,
        readAll: service_permissions_1.ServicePermissions.TODO_TEMPLATE_READ,
        update: service_permissions_1.ServicePermissions.TODO_TEMPLATE_WRITE
    },
    searchableFields: [
        { name: "label", weight: 10 },
        { name: "description", weight: 8 }
    ],
    toStringRepresentation: "${label}",
    url: "${backofficeProjectPath}/todos",
    tags: []
};
exports.FileType = {
    icon: "opened-folder",
    name: "files",
    permissions: {
        create: service_permissions_1.ServicePermissions.FILES_WRITE,
        delete: service_permissions_1.ServicePermissions.FILES_WRITE,
        read: service_permissions_1.ServicePermissions.FILES_READ,
        readAll: service_permissions_1.ServicePermissions.FILES_READ,
        update: service_permissions_1.ServicePermissions.FILES_WRITE
    },
    searchableFields: [{ name: "name", weight: 10 }],
    toStringRepresentation: "${name}",
    url: "${backofficeProjectPath}/files",
    tags: [type_1.SmallstackTypeTag.LINK_FOR_CALENDAR, type_1.SmallstackTypeTag.COMMON, type_1.SmallstackTypeTag.LINK_FOR_TODO]
};
exports.WorkflowType = {
    icon: "serial-tasks--v1",
    name: "workflows",
    permissions: {
        create: service_permissions_1.ServicePermissions.WORKFLOW_WRITE,
        delete: service_permissions_1.ServicePermissions.WORKFLOW_WRITE,
        read: service_permissions_1.ServicePermissions.WORKFLOW_READ,
        readAll: service_permissions_1.ServicePermissions.WORKFLOW_READ,
        update: service_permissions_1.ServicePermissions.WORKFLOW_WRITE
    },
    searchableFields: [
        { name: "label", weight: 10 },
        { name: "name", weight: 2 },
        { name: "description", weight: 10 }
    ],
    toStringRepresentation: "${label}",
    url: "${backofficeProjectPath}/workflow/${id}",
    tags: []
};
exports.ProductType = {
    icon: "new-product",
    name: "products",
    permissions: {
        create: service_permissions_1.ServicePermissions.PRODUCTS_WRITE,
        delete: service_permissions_1.ServicePermissions.PRODUCTS_WRITE,
        read: service_permissions_1.ServicePermissions.PRODUCTS_READ,
        readAll: service_permissions_1.ServicePermissions.PRODUCTS_READ,
        update: service_permissions_1.ServicePermissions.PRODUCTS_WRITE
    },
    searchableFields: [
        { name: "title", weight: 10 },
        { name: "shortTitle", weight: 9 },
        { name: "description", weight: 10 },
        { name: "shortDescription", weight: 9 }
    ],
    toStringRepresentation: "${title}",
    url: "${backofficeProjectPath}/products/${id}",
    tags: []
};
exports.CmsPageType = {
    icon: "template",
    name: "cmsPages",
    permissions: {
        create: service_permissions_1.ServicePermissions.CMS_WRITE,
        delete: service_permissions_1.ServicePermissions.CMS_WRITE,
        read: service_permissions_1.ServicePermissions.CMS_READ,
        readAll: service_permissions_1.ServicePermissions.CMS_READ,
        update: service_permissions_1.ServicePermissions.CMS_WRITE
    },
    searchableFields: [
        { name: "name", weight: 4 },
        { name: "title", weight: 10 },
        { name: "tags", weight: 9 }
    ],
    toStringRepresentation: "${title}",
    url: "${backofficeProjectPath}/products/${id}",
    tags: []
};
exports.ApplicationType = {
    icon: "module",
    name: "applications",
    permissions: {
        create: service_permissions_1.ServicePermissions.APPLICATIONS_WRITE,
        delete: service_permissions_1.ServicePermissions.APPLICATIONS_WRITE,
        read: service_permissions_1.ServicePermissions.APPLICATIONS_READ,
        readAll: service_permissions_1.ServicePermissions.APPLICATIONS_READ,
        update: service_permissions_1.ServicePermissions.APPLICATIONS_WRITE
    },
    searchableFields: [{ name: "title", weight: 10 }],
    toStringRepresentation: "${title}",
    url: "${backofficeProjectPath}/applications/${id}",
    tags: []
};
exports.OptinType = {
    icon: "keyhole-shield",
    name: "optins",
    permissions: {
        create: service_permissions_1.ServicePermissions.OPT_IN_WRITE,
        delete: service_permissions_1.ServicePermissions.OPT_IN_WRITE,
        read: service_permissions_1.ServicePermissions.ANONYMOUS,
        readAll: service_permissions_1.ServicePermissions.ANONYMOUS,
        update: service_permissions_1.ServicePermissions.OPT_IN_WRITE
    },
    searchableFields: [
        { name: "title", weight: 10 },
        { name: "text", weight: 10 }
    ],
    toStringRepresentation: "${title}",
    url: "${backofficeProjectPath}/optin",
    tags: []
};
exports.ConfigurationType = {
    icon: "gear",
    name: "configurations",
    permissions: {
        create: service_permissions_1.ServicePermissions.CONFIGURATION_WRITE,
        delete: service_permissions_1.ServicePermissions.CONFIGURATION_WRITE,
        read: service_permissions_1.ServicePermissions.CONFIGURATION_READ,
        readAll: service_permissions_1.ServicePermissions.CONFIGURATION_READ,
        update: service_permissions_1.ServicePermissions.CONFIGURATION_WRITE
    },
    searchableFields: [
        { name: "key", weight: 10 },
        { name: "value", weight: 10 }
    ],
    toStringRepresentation: "${key}",
    url: "${backofficeProjectPath}/configurations",
    tags: []
};
exports.DeviceType = {
    icon: "multiple-devices",
    name: "devices",
    permissions: {
        create: service_permissions_1.ServicePermissions.DEVICES_WRITE,
        delete: service_permissions_1.ServicePermissions.DEVICES_WRITE,
        read: service_permissions_1.ServicePermissions.DEVICES_READ,
        readAll: service_permissions_1.ServicePermissions.DEVICES_READ,
        update: service_permissions_1.ServicePermissions.DEVICES_WRITE
    },
    searchableFields: [{ name: "name", weight: 10 }],
    toStringRepresentation: "${name}",
    url: "${backofficeProjectPath}/devices",
    tags: []
};
exports.CustomBackofficeType = {
    icon: "web",
    name: "custombackoffices",
    permissions: {
        create: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        delete: service_permissions_1.ServicePermissions.TENANT_ADMIN,
        read: service_permissions_1.ServicePermissions.ANONYMOUS,
        readAll: service_permissions_1.ServicePermissions.ANONYMOUS,
        update: service_permissions_1.ServicePermissions.TENANT_ADMIN
    },
    searchableFields: [{ name: "title", weight: 10 }],
    toStringRepresentation: "${title}",
    tags: [type_1.SmallstackTypeTag.ADMIN]
};
exports.SupplierType = {
    icon: "supplier",
    name: "suppliers",
    permissions: {
        create: service_permissions_1.ServicePermissions.SUPPLIERS_WRITE,
        delete: service_permissions_1.ServicePermissions.SUPPLIERS_WRITE,
        read: service_permissions_1.ServicePermissions.SUPPLIERS_READ,
        readAll: service_permissions_1.ServicePermissions.SUPPLIERS_READ,
        update: service_permissions_1.ServicePermissions.SUPPLIERS_WRITE
    },
    searchableFields: [
        { name: "title", weight: 10 },
        { name: "code", weight: 1 }
    ],
    toStringRepresentation: "${title}",
    tags: []
};
exports.ShoppingCartType = {
    icon: "shopping-cart--v1",
    name: "shoppingcarts",
    permissions: {
        create: service_permissions_1.ServicePermissions.SHOPPING_CARTS_WRITE,
        delete: service_permissions_1.ServicePermissions.SHOPPING_CARTS_WRITE,
        read: service_permissions_1.ServicePermissions.SHOPPING_CARTS_READ,
        readAll: service_permissions_1.ServicePermissions.SHOPPING_CARTS_READ,
        update: service_permissions_1.ServicePermissions.SHOPPING_CARTS_WRITE
    },
    tags: []
};
exports.PriceZoneType = {
    icon: "price-tag--v1",
    name: "pricezones",
    permissions: {
        create: service_permissions_1.ServicePermissions.PRODUCTS_WRITE,
        delete: service_permissions_1.ServicePermissions.PRODUCTS_WRITE,
        read: service_permissions_1.ServicePermissions.PRODUCTS_READ,
        readAll: service_permissions_1.ServicePermissions.PRODUCTS_READ,
        update: service_permissions_1.ServicePermissions.PRODUCTS_WRITE
    },
    tags: []
};
exports.OrderType = {
    icon: "purchase-order",
    name: "orders",
    permissions: {
        create: service_permissions_1.ServicePermissions.ORDERS_WRITE,
        delete: service_permissions_1.ServicePermissions.ORDERS_WRITE,
        read: service_permissions_1.ServicePermissions.ORDERS_READ,
        readAll: service_permissions_1.ServicePermissions.ORDERS_READ,
        update: service_permissions_1.ServicePermissions.ORDERS_WRITE
    },
    tags: []
};
exports.MessageType = {
    icon: "chat--v1",
    name: "messages",
    tags: []
};
exports.TaskType = {
    icon: "tasks--v1",
    name: "tasks",
    permissions: {
        create: service_permissions_1.ServicePermissions.TASKS_WRITE,
        delete: service_permissions_1.ServicePermissions.TASKS_WRITE,
        read: service_permissions_1.ServicePermissions.TASKS_READ,
        readAll: service_permissions_1.ServicePermissions.TASKS_READ,
        update: service_permissions_1.ServicePermissions.TASKS_WRITE
    },
    tags: []
};
exports.DashboardType = {
    icon: "tasks--v1",
    name: "dashboards",
    tags: []
};
exports.CronjobType = {
    icon: "refresh--v1",
    name: "cronjobs",
    permissions: {
        create: service_permissions_1.ServicePermissions.CRONJOB_WRITE,
        delete: service_permissions_1.ServicePermissions.CRONJOB_WRITE,
        read: service_permissions_1.ServicePermissions.CRONJOB_READ,
        readAll: service_permissions_1.ServicePermissions.CRONJOB_READ,
        update: service_permissions_1.ServicePermissions.CRONJOB_WRITE
    },
    tags: []
};
exports.DataTypeType = {
    icon: "database",
    name: "datatypes",
    permissions: {
        create: service_permissions_1.ServicePermissions.DATATYPES_WRITE,
        delete: service_permissions_1.ServicePermissions.DATATYPES_WRITE,
        read: service_permissions_1.ServicePermissions.ANONYMOUS,
        readAll: service_permissions_1.ServicePermissions.ANONYMOUS,
        update: service_permissions_1.ServicePermissions.DATATYPES_WRITE
    },
    tags: []
};
exports.LocaleType = {
    icon: "europe",
    name: "locales",
    permissions: {
        create: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE,
        delete: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE,
        read: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_READ,
        readAll: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_READ,
        update: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE
    },
    tags: [type_1.SmallstackTypeTag.ADMIN]
};
exports.CountryType = {
    icon: "europe",
    name: "countries",
    permissions: {
        create: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE,
        delete: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE,
        read: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_READ,
        readAll: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_READ,
        update: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE
    },
    tags: [type_1.SmallstackTypeTag.ADMIN]
};
exports.LanguageType = {
    icon: "europe",
    name: "languages",
    permissions: {
        create: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE,
        delete: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE,
        read: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_READ,
        readAll: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_READ,
        update: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE
    },
    tags: [type_1.SmallstackTypeTag.ADMIN]
};
exports.TranslationType = {
    icon: "europe",
    name: "translations",
    permissions: {
        create: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE,
        delete: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE,
        read: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_READ,
        readAll: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_READ,
        update: service_permissions_1.ServicePermissions.INTERNATIONALIZATION_WRITE
    },
    tags: [type_1.SmallstackTypeTag.ADMIN]
};
exports.EmailType = {
    icon: "secured-letter",
    name: "emails",
    permissions: {
        create: service_permissions_1.ServicePermissions.EMAILS_WRITE,
        delete: service_permissions_1.ServicePermissions.EMAILS_WRITE,
        read: service_permissions_1.ServicePermissions.EMAILS_READ,
        readAll: service_permissions_1.ServicePermissions.EMAILS_READ,
        update: service_permissions_1.ServicePermissions.EMAILS_WRITE
    },
    tags: [type_1.SmallstackTypeTag.ADMIN]
};
exports.EmailTemplateType = {
    icon: "secured-letter",
    name: "emailtemplates",
    permissions: {
        create: service_permissions_1.ServicePermissions.EMAILTEMPLATES_WRITE,
        delete: service_permissions_1.ServicePermissions.EMAILTEMPLATES_WRITE,
        read: service_permissions_1.ServicePermissions.EMAILTEMPLATES_READ,
        readAll: service_permissions_1.ServicePermissions.EMAILTEMPLATES_READ,
        update: service_permissions_1.ServicePermissions.EMAILTEMPLATES_WRITE
    },
    tags: [type_1.SmallstackTypeTag.ADMIN]
};
exports.FormType = {
    icon: "form",
    name: "forms",
    permissions: {
        create: service_permissions_1.ServicePermissions.FORMS_WRITE,
        delete: service_permissions_1.ServicePermissions.FORMS_WRITE,
        read: service_permissions_1.ServicePermissions.ANONYMOUS,
        readAll: service_permissions_1.ServicePermissions.ANONYMOUS,
        update: service_permissions_1.ServicePermissions.FORMS_WRITE
    },
    tags: [type_1.SmallstackTypeTag.ADMIN],
    searchableFields: [
        {
            name: "title.value",
            weight: 10
        }
    ],
    toStringRepresentation: "${title}",
    url: "${backofficeProjectPath}/forms"
};
exports.WorklogType = {
    icon: "work",
    name: "worklogs",
    permissions: {
        create: service_permissions_1.ServicePermissions.WORKLOG_WRITE,
        delete: service_permissions_1.ServicePermissions.WORKLOG_WRITE,
        read: service_permissions_1.ServicePermissions.WORKLOG_READ,
        readAll: service_permissions_1.ServicePermissions.WORKLOG_READ,
        update: service_permissions_1.ServicePermissions.WORKLOG_WRITE
    },
    tags: [type_1.SmallstackTypeTag.COMMON],
    searchableFields: [
        {
            name: "label",
            weight: 10
        }
    ],
    toStringRepresentation: "${label}"
};
exports.MyWorklogType = Object.assign(Object.assign({}, exports.WorklogType), { name: "myworklogs", permissions: {
        create: service_permissions_1.ServicePermissions.WORKLOG_OWNER_WRITE,
        delete: service_permissions_1.ServicePermissions.WORKLOG_OWNER_WRITE,
        read: service_permissions_1.ServicePermissions.WORKLOG_OWNER_READ,
        readAll: service_permissions_1.ServicePermissions.WORKLOG_OWNER_READ,
        update: service_permissions_1.ServicePermissions.WORKLOG_OWNER_WRITE
    } });
exports.CheckinVisitorType = {
    icon: "queue",
    name: "visitors",
    tags: []
};
exports.CheckinVisitorEventType = {
    icon: "event",
    name: "visitorevents",
    tags: []
};
exports.CheckinAppType = {
    icon: "app-symbol",
    name: "apps",
    tags: []
};
exports.PrinterConfigurationType = {
    icon: "printer",
    name: "printerconfigurations",
    tags: []
};
exports.PdfTemplateType = {
    icon: "pdf",
    name: "PdfTemplates",
    permissions: {
        create: service_permissions_1.ServicePermissions.PDF_TEMPLATE_WRITE,
        delete: service_permissions_1.ServicePermissions.PDF_TEMPLATE_WRITE,
        read: service_permissions_1.ServicePermissions.PDF_TEMPLATE_READ,
        readAll: service_permissions_1.ServicePermissions.PDF_TEMPLATE_READ,
        update: service_permissions_1.ServicePermissions.PDF_TEMPLATE_WRITE
    },
    tags: []
};
/** A collection of all statically known smallstack types */
exports.StaticTypes = [
    exports.ApplicationType,
    exports.CalendarEntryType,
    exports.CalendarType,
    exports.CheckinAppType,
    exports.CheckinVisitorEventType,
    exports.CheckinVisitorType,
    exports.CmsPageType,
    exports.ConfigurationType,
    exports.ContactType,
    exports.CountryType,
    exports.CronjobType,
    exports.CustomBackofficeType,
    exports.CustomerType,
    exports.DashboardType,
    exports.DataTypeType,
    exports.DeviceType,
    exports.ExtensionSlotType,
    exports.EmailTemplateType,
    exports.EmailType,
    exports.FileType,
    exports.FormType,
    exports.LanguageType,
    exports.LocaleType,
    exports.MessageType,
    exports.OptinType,
    exports.OrderType,
    exports.PdfTemplateType,
    exports.PriceZoneType,
    exports.PrinterConfigurationType,
    exports.ProductType,
    exports.RoleType,
    exports.DataTemplateType,
    exports.ProjectType,
    exports.ServiceTokenType,
    exports.ShoppingCartType,
    exports.SubscriptionType,
    exports.SupplierType,
    exports.TaskType,
    exports.TodoTemplateType,
    exports.TodoType,
    exports.TranslationType,
    exports.UserType,
    exports.WorkflowType,
    exports.WorklogType
];
